module.exports = __webpack_public_path__ + "static/media/search-document.1e0eacdf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/backgrounds/search-document.svg
// module id = 505
// module chunks = 0